<script setup>
  import captchagen from "captchagen";
  import svgIcon from "@/assets/svg-icon";
  import { onMounted, ref } from "vue";
  import { useAlertStore } from "@/stores";

  const captchaText = ref('');
  const capcthaInput = ref('');
  const capcthaImg = ref('');
  const alertStore = useAlertStore();

  const generateRandomString = (length = 4) => {
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  const generateCaptcha = () => {
    const text = generateRandomString(4);

    const captcha = captchagen.create({
      text: text, // Use the generated 4-character string
      width: 400, // Width of the CAPTCHA image
      height: 125, // Height of the CAPTCHA image
    });
    
    capcthaInput.value = '';
    captchaText.value = text;
    captcha.generate();
    capcthaImg.value = captcha.uri();
  };

  const verifyCapctha = () => {
    let status = true;
    if (captchaText.value != capcthaInput.value) {
      status = false;
      alertStore.error("CAPTCHA tidak sesuai");
      generateCaptcha();
    }
    return status;
  };

  onMounted(() => {
    generateCaptcha();
  });

  defineExpose({
    verifyCapctha,
    generateCaptcha,
  });
</script>

<template>
  <img :src="capcthaImg" alt="captcha" style="width: 100%; height: 100px;" />
  <div class="input-group mt-2">
    <input v-model="capcthaInput" type="text" class="form-control" @input="captchaChange" placeholder="Masukan CAPTCHA" required />
    <div class="input-group-append">
      <button type="button" class="btn btn-warning" @click="generateCaptcha">
        <span v-html="svgIcon.refresh"></span>
      </button>
    </div>
  </div>
</template>